import React from "react";
import { Empty } from "./Empty.styles";

const EmptyCmp = props => {
  return <Empty>There is no data for this query</Empty>;
};

export default EmptyCmp;
